export const scmGoodsColumns = [
  {
    title: '图片',
    field: 'goodsImgUrl',
    fixed: 'left',
    type: 'image',
    width: 40,
  },
  {
    title: '商品名称',
    field: 'name',
    fixed: 'left',
    align: 'left',
    width: 120,
    showTooltip: true,
  },
  {
    title: '商品货号',
    align: 'left',
    field: 'goodsSn',
    showTooltip: true,
  },
  {
    title: '颜色',
    field: 'goodsColors',
    showTooltip: true,
    width: 100,
    formatter: ({ cellValue }: any): string =>
      cellValue?.map((e: Recordable) => e.colorName)?.join(','),
  },
  {
    title: '尺码',
    field: 'goodsSizes',
    showTooltip: true,
    width: 100,
    formatter: ({ cellValue }: any): string =>
      cellValue?.map((e: Recordable) => e.sizeName)?.join(','),
  },
  {
    title: '最后更新时间',
    field: 'updateTime',
    type: 'day',
    format: 'YYYY-MM-DD HH:mm:ss',
    width: 100,
  },
  {
    title: '绑定状态',
    field: 'isBindJst',
    width: 80,
    formatter: ({ cellValue }: any): string => {
      return cellValue ? '已绑定' : '未绑定';
    },
  },
  {
    title: '操作',
    field: 'operate',
    type: 'operate',
    fixed: 'right',
    align: 'center',
    width: 80,
  },
];

export const jstGoodsColumns = [
  {
    title: '图片',
    field: 'pic',
    fixed: 'left',
    type: 'image',
    width: 40,
  },
  {
    title: '聚水潭商品名称',
    field: 'jstGoodsName',
    fixed: 'left',
    align: 'left',
    width: 120,
    showTooltip: true,
  },
  {
    title: '聚水潭货号',
    align: 'left',
    field: 'jstGoodsSn',
    showTooltip: true,
  },
  {
    title: '颜色',
    field: 'jstColors',
    showTooltip: true,
    width: 100,
    formatter: ({ cellValue }: any): string => cellValue?.join(','),
  },
  {
    title: '尺码',
    field: 'jstSizes',
    showTooltip: true,
    width: 100,
    formatter: ({ cellValue }: any): string => cellValue?.join(','),
  },
  {
    title: '创建时间',
    field: 'createTime',
    type: 'day',
    format: 'YYYY-MM-DD HH:mm:ss',
    width: 100,
  },
  {
    title: '更新时间',
    field: 'updateTime',
    type: 'day',
    format: 'YYYY-MM-DD HH:mm:ss',
    width: 100,
  },
  {
    title: '绑定状态',
    field: 'isBinding',
    width: 80,
    formatter: ({ cellValue }: any): string => {
      return cellValue ? '已绑定' : '未绑定';
    },
  },
];

export const kmGoodsColumns = [
  {
    title: '图片',
    field: 'goodsImgUrl',
    fixed: 'left',
    type: 'image',
    width: 40,
  },
  {
    title: '快麦商品名称',
    field: 'goodsName',
    fixed: 'left',
    align: 'left',
    width: 120,
    showTooltip: true,
  },
  {
    title: '快麦货号',
    align: 'left',
    field: 'goodsSn',
    showTooltip: true,
  },
  {
    title: '颜色',
    field: 'colors',
    showTooltip: true,
    width: 100,
    formatter: ({ cellValue }: any): string => cellValue?.join(','),
  },
  {
    title: '尺码',
    field: 'sizes',
    showTooltip: true,
    width: 100,
    formatter: ({ cellValue }: any): string => cellValue?.join(','),
  },
  {
    title: '快麦创建时间',
    field: 'goodsCreateTime',
    type: 'day',
    format: 'YYYY-MM-DD HH:mm:ss',
    width: 100,
  },
  {
    title: '快麦更新时间',
    field: 'goodsUpdateTime',
    type: 'day',
    format: 'YYYY-MM-DD HH:mm:ss',
    width: 100,
  },
  {
    title: '生产商品名称',
    field: 'scmGoodsName',
    align: 'left',
    width: 120,
    showTooltip: true,
    formatter: ({ row }: any) => {
      return row.scmGoods?.name || '-';
    },
  },
  {
    title: '生产货号',
    align: 'left',
    field: 'scmGoodsSn',
    showTooltip: true,
    formatter: ({ row }: any) => {
      return row.scmGoods?.goodsSn || '-';
    },
  },
  {
    title: '绑定状态',
    field: 'goodsRelationState',
    width: 80,
    formatter: ({ cellValue }: any): string => {
      return cellValue ? '已绑定' : '未绑定';
    },
  },
];

export const scmGoodsColumnsForKM = [
  {
    title: '图片',
    field: 'goodsImgUrl',
    fixed: 'left',
    type: 'image',
    width: 40,
  },
  {
    title: '商品名称',
    field: 'name',
    fixed: 'left',
    align: 'left',
    width: 120,
    showTooltip: true,
  },
  {
    title: '货号',
    align: 'left',
    field: 'goodsSn',
    showTooltip: true,
  },
  {
    title: '颜色',
    field: 'goodsColors',
    showTooltip: true,
    width: 100,
    formatter: ({ cellValue }: any): string =>
      cellValue?.map((e: Recordable) => e.colorName)?.join(','),
  },
  {
    title: '尺码',
    field: 'goodsSizes',
    showTooltip: true,
    width: 100,
    formatter: ({ cellValue }: any): string =>
      cellValue?.map((e: Recordable) => e.sizeName)?.join(','),
  },
  {
    title: '最后更新时间',
    field: 'updateTime',
    type: 'day',
    format: 'YYYY-MM-DD HH:mm:ss',
    width: 100,
  },
  {
    title: '快麦商品名称',
    field: 'kmGoodsName',
    showTooltip: true,
    formatter: ({ row }: any) => {
      return row.kmGoods?.goodsName || '-';
    },
  },
  {
    title: '快麦商品货号',
    field: 'kmGoodsSn',
    showTooltip: true,
    formatter: ({ row }: any) => {
      return row.kmGoods?.goodsSn || '-';
    },
  },
  {
    title: '绑定状态',
    field: 'isBindKm',
    width: 80,
    formatter: ({ cellValue }: any): string => {
      return cellValue ? '已绑定' : '未绑定';
    },
  },
  {
    title: '操作',
    field: 'operate',
    type: 'operate',
    fixed: 'right',
    align: 'center',
    width: 80,
  },
];

export const scmSupplierColumns = [
  {
    title: '自主生产',
    field: 'isJstAlone',
    type: 'slot',
    slotName: 'isJstAlone',
    align: 'center',
    tips: '当生产系统为自主生产类型时，对应聚水潭的供应商',
    width: 60,
  },
  {
    title: '供应商名称',
    field: 'supplierName',
    align: 'left',
    width: 120,
    showTooltip: true,
  },
  {
    title: '绑定状态',
    field: 'jstBindState',
    width: 80,
    formatter: ({ cellValue }: any): string => {
      return cellValue ? '已绑定' : '未绑定';
    },
  },
  {
    title: '聚水潭供应商',
    align: 'left',
    field: 'jstSupplierName',
    showTooltip: true,
  },
  {
    title: '供应商内部编码',
    align: 'left',
    field: 'jstSupplierId',
  },
  {
    title: '操作',
    field: 'operate',
    type: 'operate',
    fixed: 'right',
    align: 'center',
    width: 80,
  },
];

export const scmSupplierColumnsForKM = [
  {
    title: '自主生产',
    field: 'isHouseProduce',
    type: 'slot',
    slotName: 'isHouseProduce',
    align: 'center',
    tips: '当生产系统为自主生产类型时，对应快麦的供应商',
    width: 60,
  },
  {
    title: '供应商名称',
    field: 'supplierName',
    width: 120,
    showTooltip: true,
  },
  {
    title: '外部编码',
    field: 'tpSupplierCode',
  },
  {
    title: '绑定状态',
    field: 'kmBindState',
    width: 80,
    formatter: ({ cellValue }: any): string => {
      return cellValue ? '已绑定' : '未绑定';
    },
  },
  {
    title: '快麦供应商',
    field: 'tpSupplierName',
    formatter: ({ row }: any) => {
      return row.kmBindState ? row.kmSupplier?.tpSupplierName ?? '-' : '';
    },
    showTooltip: true,
  },
  {
    title: '快麦供应商编码',
    field: 'kmTpSupplierCode',
    formatter: ({ row }: any) => {
      return row.kmBindState ? row.kmSupplier?.tpSupplierCode ?? '-' : '';
    },
  },
];
export const kmSupplierColumns = [
  {
    title: '快麦供应商',
    field: 'name',
  },
  {
    title: '快麦供应商编码',
    field: 'code',
  },
  {
    title: '创建日期',
    field: 'created',
    type: 'day',
    format: 'YYYY-MM-DD HH:mm:ss',
  },
  {
    title: '最后修改日期',
    field: 'modified',
    type: 'day',
    format: 'YYYY-MM-DD HH:mm:ss',
  },
];
export const syncLogColumn = [
  {
    title: '同步状态',
    field: 'status',
    formatter: ({ cellValue }: any): string => {
      return cellValue === 1 ? '同步成功' : '同步失败';
    },
    width: 60,
  },
  {
    title: '业务类型',
    field: 'businessItem',
    type: 'slot',
    slotName: 'businessItem',
    /*     formatter: ({ cellValue }: any): string => {
      return SYNCLOG_BUSINESS_TYPE[cellValue] || '-';
    }, */
    width: 60,
  },
  {
    title: '内容',
    field: 'content',
    default: '-',
    width: 200,
  },
  {
    title: '失败原因',
    field: 'message',
    default: '-',
  },
  {
    title: '解决方案',
    field: 'solution',
    default: '-',
  },
  {
    title: '创建时间',
    field: 'createTime',
    type: 'day',
    format: 'YYYY-MM-DD HH:mm',
  },
  {
    title: '同步单据',
    field: 'syncTaskRelationBusinesses',
    type: 'slot',
    slotName: 'relationBusinesses',
  },
  {
    title: '操作',
    type: 'operate',
    width: 60,
  },
];

export const SYNCLOG_BUSINESS_TYPE: Recordable = {
  1: '采购单',
  2: '退货单',
  3: '入库单',
};

export const SYNCLOG_BUSINESS_TYPE_KM: Recordable = {
  5: '采退单',
  6: '采购单',
  7: '收货单',
};
export const SYNCLOG_RELATION_BUSINESS_TYPE: Recordable = {
  2: '生产单',
  17: '生产请求单',
  36: '生产出库单',
  38: '生产入库单',
  37: '出库退货单',
};

export const exportSupplierFieldMap: Recordable = {
  供应商内部编号: 'jstSupplierId',
  // 供应商名: 'supplierName',
  // 供应商编码: 'supplierCode',
};

export const exportSupplierFieldMapForKM: Recordable = {
  供应商编码: 'tpSupplierCode',
  供应商名称: 'tpSupplierName',
};

export const AUTO_UPDATE_COLOR_SIZE: Recordable = {
  1: '按生产系统更新',
  2: '按聚水潭系统更新',
};

export const jstSyncDefaultConfig = {
  purchaseSyncPriceType: undefined, // 采购同步价格类型
  purchaseSyncPricePercent: 100, // 采购同步价格百分比
};
export const PURCHASE_SYNC_PRICE_TYPE = {
  TAG_PRICE: 1, // 吊牌价
  RETAIL_PRICE_FACTORY: 2, // 建议零售价
  COST_PRICE: 3, // 成本价
  TRADE_PRICE: 4, // 批发价
  RETAIL_PRICE_AREA: 5, // 零售价
  LAST_TIME_PURCHASE_PRICE: 6, // 上次采购单价格
  FINISH_GOODS_PURCHASE_PRICE: 7, // 成品采购单采购单价
};

export const purchaseSyncPriceTypeOptions = [
  {
    label: '吊牌价',
    value: PURCHASE_SYNC_PRICE_TYPE.TAG_PRICE,
  },
  {
    label: '建议零售价',
    value: PURCHASE_SYNC_PRICE_TYPE.RETAIL_PRICE_FACTORY,
  },
  {
    label: '成本价',
    value: PURCHASE_SYNC_PRICE_TYPE.COST_PRICE,
  },
  {
    label: '批发价',
    value: PURCHASE_SYNC_PRICE_TYPE.TRADE_PRICE,
  },
  {
    label: '零售价',
    value: PURCHASE_SYNC_PRICE_TYPE.RETAIL_PRICE_AREA,
  },
  {
    label: '上次采购单价格',
    value: PURCHASE_SYNC_PRICE_TYPE.LAST_TIME_PURCHASE_PRICE,
  },
  {
    label: '成品采购单采购单价',
    value: PURCHASE_SYNC_PRICE_TYPE.FINISH_GOODS_PURCHASE_PRICE,
  },
];
